<!--考号-->
<template>
	<div>
		<div class="drop-position" :style="concludeWH" ref="config">
			<vue-drag-resize
				class="mark-out-position"
				v-for="(rectItem, rectIndex) in rectDetail"
				:class="rectItem.appendInfo ? 'pointer-active' : 'pointer-none'"
				v-show="tempCurrentImgIndex.curIndex + 1 === Number(JSON.parse(rectItem.remarks).page)"
				:key="rectItem.pkId"
				:x="rectItem.areaMinX"
				:y="rectItem.areaMinY"
				:w="operateWidth(rectItem)"
				:h="operateHeight(rectItem)"
				:isActive="rectIndex === tempActiveArea"
				:isDraggable="rectIndex === tempActiveArea"
				:isResizable="rectIndex === tempActiveArea"
				@click.native="exitDrag"
				@resizestop="rectDragResize($event, rectIndex)"
				@dragstop="rectDragResize($event, rectIndex)"
			>
				<template v-if="!rectItem.isShowChild">
					<div class="rect-title-wrap" @mousedown="addExamNoRect($event, rectItem, rectIndex, rectItem.areaMinX, rectItem.areaMinY)">
						<vue-drag-resize
							class="mark-list"
							:class="{ 'mark-list-active': index === examNoActiveIndex }"
							v-for="(item, index) in JSON.parse(rectItem.appendInfo).box"
							:key="index"
							:x="Number(item.x)"
							:y="Number(item.y)"
							:w="Number(item.w)"
							:h="Number(item.h)"
							:isActive="false"
							:isResizable="false"
							:isDraggable="true"
							@mousedown.native="fixRectList($event, rectItem, item, rectIndex, index)"
							@dragstop="handleExamNoDragResize($event, index)"
						>
							<span class="mark-val" @mousedown="fixRectList($event, rectItem, item, rectIndex, index)">{{ item.v | filterVal }}</span>
						</vue-drag-resize>
						<i class="iconfont iconlajitong1 del-icon" @click="dropArea({ val: rectItem, state: true })" title="删除"></i>
						<div class="drop-menu">
							<el-dropdown class="el-dropdown-link" @command="dropDownMenu($event, { val: rectItem, curIndex: rectIndex })" title="更多操作">
								<i class="iconfont iconjiantou-down "></i>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="drag">拖拽选区</el-dropdown-item>
									<el-dropdown-item command="rotate">旋转选区</el-dropdown-item>
									<el-dropdown-item command="del">删除选区</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</div>
				</template>
			</vue-drag-resize>
		</div>
		<portal to="ope-dialog">
			<div class="recognise-wrap">
				<div class="recognise-my-no" @scroll="scrollChange($event)">
					<div class="my-reco-wrap" ref="myRecognise">
						<img :src="clipImg" alt="" style="max-width: 100%" ref="myRecogniseImg" />
						<vue-drag-resize
							class="my-recognise-wrap"
							:class="{ 'my-recognise-wrap-active': handleActive }"
							:x="resizeDragVal.left"
							:y="resizeDragVal.top"
							:w="resizeDragVal.width || 10"
							:h="resizeDragVal.height || 10"
							:isActive="isRecogniseDo"
							:isDraggable="isRecogniseDo"
							:isResizable="isRecogniseDo"
							@clicked="activeHandleRect"
							@resizestop="resizestop(resizeDragVal, $event)"
							@dragstop="dragstop"
						>
							<template>
								<vue-drag-resize
									class="my-recognise-rect"
									v-for="(item, index) in resultBox"
									:key="index"
									:x="item.x"
									:y="item.y"
									:w="item.w"
									:h="item.h"
									:isDraggable="true"
									:isResizable="false"
									@dragstop="dragBoxStop($event, index)"
								>
									{{ item.v }}
								</vue-drag-resize>
							</template>
						</vue-drag-resize>
					</div>
				</div>
				<el-button type="primary" style="position: fixed;right: 10px;top: 10px" @mouseover.native="handleDrawState">操作区域</el-button>
				<el-drawer title="操作区域" :visible.sync="drawerState" :direction="direction" :append-to-body="true" size="230">
					<div class="recognise-handle">
						<el-form ref="form" :model="opeForm" label-width="45px">
							<el-form-item label="行数">
								<step :defaultVal="opeForm.rowNum" key="rowNum" @stepVal="rowNumStepVal($event, 'rowNum')"></step>
							</el-form-item>
							<el-form-item label="列数">
								<step :defaultVal="opeForm.colNum" key="colNum" @stepVal="rowNumStepVal($event, 'colNum')"></step>
							</el-form-item>
							<el-form-item label="宽度">
								<step :defaultVal="opeForm.width" key="width" @stepVal="rowNumStepVal($event, 'width')"></step>
							</el-form-item>
							<el-form-item label="高度">
								<step :defaultVal="opeForm.height" key="height" @stepVal="rowNumStepVal($event, 'height')"></step>
							</el-form-item>
							<el-button class="btn-style greenBg" type="success" @click="verticalDownRotation">竖直向下旋转</el-button>
							<el-button class="btn-style greenBg" type="success" @click="verticalUpRotation">竖直向上旋转</el-button>
							<el-button class="btn-style greenBg" type="success" @click="horizontalRightRotation">水平向右旋转</el-button>
							<el-button class="btn-style greenBg" type="success" @click="horizontalLeftRotation">水平向左旋转</el-button>
							<el-button class="btn-style" type="primary" @click="generateNo">预览</el-button>
							<el-button class="btn-style" type="primary" @click="saveExamNo">保存</el-button>
							<el-button class="btn-style" type="primary" @click="backRecognise">返回</el-button>
						</el-form>
					</div>
				</el-drawer>
			</div>
		</portal>
	</div>
</template>
<script>
import VueDragResize from 'vue-drag-resize'
import isDragResize from '@/views/template-configuration/utils/mixin/is-drag-resize'
import drawRect from '@/views/template-configuration/utils/mixin/draw-rect'
import fixWH from '@/views/template-configuration/utils/mixin/fix-wh'
import fixRect from '@/views/template-configuration/utils/mixin/fix-rect'
import examNoHandle from '../utils/mixin/exam-no-handle'
import { refreshBox } from '../utils/js/help'
import { recognizeExamNo } from '../utils/js/recognise'
import { mapGetters } from 'vuex'
export default {
	name: 'temp-No',
	mixins: [drawRect, isDragResize, fixWH, fixRect, examNoHandle],
	components: {
		VueDragResize,
		step: () => import('../utils/component/step')
	},
	data() {
		return {
			//款子u
			rectDetail: [],
			//缓存框子
			rectDetailInfo: {},
			query: this.$route.query,
			//no use
			clickTimes: 0,
			//type
			emitType: 'tempRectExamNo',
			//试卷
			currentImg: '',
			//激活索引
			examNoActiveIndex: null,
			//是否拖拽
			isDragRect: false,
			//no use
			fakeRectItem: {},
			//是否手动配置
			handleActive: false,
			//手动配置及
			drawerState: false,
			//手动配置  抽屉 方向
			direction: 'rtl',
			//滚动值
			scrollVal: 0
		}
	},
	watch: {
		//考号框子信息
		tempRectExamNoInfo: {
			handler(val) {
				this.rectDetail = val
			},
			immediate: true,
			deep: true
		},
		//答题卡 图片信息
		tempEditImgInfo: {
			handler(val) {
				this.currentImg = val.list[this.tempCurrentImgIndex.curIndex]
			},
			immediate: true
		},
		//左侧 题目类型tab
		tabActive: {
			handler() {
				this.examNoActiveIndex = null
			},
			immediate: true
		},
		//是否手动配置
		handHandleState(val) {
			this.drawerState = val
		}
	},
	computed: {
		...mapGetters('examination/configation', ['tempRectExamNoInfo', 'handHandleState', 'tabActive', 'handHandleState'])
	},
	filters: {
		filterVal(val) {
			if ((!val || val === 'undefined') && val !== 0) return ''
			return val
		}
	},
	mounted() {
		this.handleDelKey()
		this.drawRectList()
	},
	methods: {
		scrollChange(event) {
			this.resizeDragVal.top = this.resizeDragValTop - event.target.scrollTop
			this.scrollVal = event.target.scrollTop
		},
		//删除小框框
		handleDelKey() {
			const _this = this
			window.addEventListener('keydown', async function(event) {
				if (!_this.handHandleState && event.keyCode === 46 && this.examNoActiveIndex !== -1 && _this.tabActive === 'examNo') {
					let rectDetail = _this.rectDetail[0]
					let appendInfo = JSON.parse(rectDetail.appendInfo)
					let box = appendInfo.box
					_this.$delete(box, _this.examNoActiveIndex)
					if (box.length % 10 === 0) {
						appendInfo.box = await recognizeExamNo(_this, box, [_this.endX, _this.endY, _this.startX, _this.startY], true)
					} else {
						appendInfo.box = box
					}
					rectDetail.appendInfo = JSON.stringify(appendInfo)
					_this.rectDetail[0] = rectDetail
					_this.refreshHandleBox(_this.rectDetail[0])
				}
			})
		},
		// 拖拽 生成好的 小框框
		handleExamNoDragResize(event, index) {
			this.isDragRect = true
			let rectDetail = this.rectDetail[0]
			let appendInfo = JSON.parse(rectDetail.appendInfo)
			let box = appendInfo.box
			if (Math.abs(box[index].x - event.left) < 2 && Math.abs(box[index].y - event.top) < 2) return false
			box[index].x = event.left
			box[index].y = event.top
			appendInfo.box = box
			rectDetail.appendInfo = JSON.stringify(appendInfo)
			this.rectDetail[0] = rectDetail
			this.refreshHandleBox(this.rectDetail[0])
		},
		//操作之后  需更新
		refreshHandleBox(rectItem) {
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: this.tempEditImgInfo.versionId,
				ppiId: rectItem['pkId'],
				ppiStr: JSON.stringify(rectItem)
			}
			refreshBox(this, 'Cv/refreshPpi', params).then(() => {
				this.isDragRect = false
				this.$message.success('成功')
				this.setTempFlushData({ state: true })
			})
		},
		// 移动小框框，获取索引
		moveExamNoMouseDown(index) {
			this.examNoActiveIndex = index
		},
		// 手动框选  小框框拖动
		dragBoxStop(event, index) {
			this.resultBox[index].x = event.left
			this.resultBox[index].y = event.top
		},
		handleDrawState() {
			this.drawerState = true
		}
	}
}
</script>

<style scoped lang="less">
@import '../utils/css/mark-point.less';
.btn-style {
	width: 100%;
	margin-top: 30px;
	margin-left: 0;
}
</style>
